﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederUtstyrsstipendDto from '../Models/VeilederUtstyrsstipendDto';

const ba1 = 'ba1';
const ba2 = 'ba2';
const ba3 = 'ba3';
const ba4 = 'ba4';
const ba5 = 'ba5';

const baValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'ba1',
        value: ba1,
        tekst: 'ba1',
    },
    {
        id: 'ba2',
        value: ba2,
        tekst: 'ba2',
    },
    {
        id: 'ba3',
        value: ba3,
        tekst: 'ba3',
    },
    {
        id: 'ba4',
        value: ba4,
        tekst: 'ba4',
    },
    {
        id: 'ba5',
        value: ba5,
        tekst: 'ba5',
    },
];

export default {
    ba1: ba1,
    ba2: ba2,
    ba3: ba3,
    ba4: ba4,
    ba5: ba5,
    baValg,
};
